/* eslint-disable max-len */
import { LitElement, html, css } from 'lit'
import '../../src/ui/shared/kula-kat-message/kula-kat-message.js'
import globalStyles from '../global-styles.js'

class NotFoundElement extends LitElement {
  render() {
    return html`
      <kula-cat-message
        title="404 - Not Found"
        bodyText="We can't seem to find the page you are looking for. The page may have been removed, renamed, or misspelled."
        catType="3"
      ></kula-cat-message>
      <button onclick="window.history.go(-1); return false;">
        Return to Previous Page
      </button>
    `
  }

  static styles = [
    globalStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 80vh;
      }
      button {
        margin-top: 20px;
        padding: 10px 20px;
        background-color: var(--DarkBlue, #3c7b90);
        color: var(--White, #f7f7f7);
        border: none;
        border-radius: 5px;
        font-size: 1.2rem;
        font-weight: 600;
        cursor: pointer;
      }
    `,
  ]
}
customElements.define('not-found', NotFoundElement)
export default NotFoundElement
